import { CaseState } from 'app/area/case/types-store';
import * as caseDataModel from 'app/area/case/case-data-model';
import { ComponentDescriptor } from 'app/infrastructure/ui/types-uischema';
import { getEntityTypeFromPath } from 'app/infrastructure/store/entity';
import { RenderMode } from 'app/types-shared';
import { LossPotentialEvaluationProps } from 'app/area/case/components/loss-potential/loss-potential-evaluation';
import { LossPotentialEvaluationTileViewProps } from 'app/area/case/components/loss-potential/loss-potential-evaluation-tile-view';
import { deepFindByKey } from 'app/infrastructure/ui/builder/default-values';

export const lossPotentialEvaluationValues = (caseState: CaseState,  uiEngineProps: any) => {
  const entityTypePath = uiEngineProps.componentDescriptor.entityTypePath;
  const entityType = getEntityTypeFromPath(entityTypePath);
  const lossPotentialEvaluationTbl = caseDataModel.tableName.lossPotentialEvaluation;
  const lossPotentialEvaluation = (caseDataModel.columnName[lossPotentialEvaluationTbl] as any);
  const lossPotentialEvaluationResidualTbl = caseDataModel.tableName.lossPotentialResidualEvaluation;
  const lossPotentialEvaluationResidual = (caseDataModel.columnName[lossPotentialEvaluationResidualTbl] as any);
  const dataTags = deepFindByKey(caseState.uiDefinition?.rootDomain, 'dataTag');
  const isLossPotential = entityType === lossPotentialEvaluationTbl;

  return {
    allowCopyFromOtherInstance: isLossPotential ? dataTags.some(dt=>dt.dataTag === lossPotentialEvaluationResidual.revNo) :
        dataTags.some(dt=>dt.dataTag === lossPotentialEvaluation.revNo),

    evaluationValidFromDefaultValue: isLossPotential ? 
      dataTags.filter(dt=>dt.dataTag === lossPotentialEvaluation.validFrom && dt.defaultValue)[0]?.defaultValue :
      dataTags.filter(dt=>dt.dataTag === lossPotentialEvaluationResidual.validFrom && dt.defaultValue)[0]?.defaultValue,

    noOfRowsResidual: caseState.editing?.values?.filter(r=>r?.hasOwnProperty(lossPotentialEvaluationResidual.revNo))?.length    
  };
};

export const editFooterDetailsButtonVisibility = ( state: CaseState, uiEngineProps: LossPotentialEvaluationProps): Partial<any> => {
  const { renderMode } = state;

  return {
    canEditFooterDetails:
      uiEngineProps.readOnly ||
      renderMode === RenderMode.read
  };
};

export const hideLossPotentialEvaluation = ( state: CaseState, uiEngineProps: LossPotentialEvaluationTileViewProps): Partial<any> => {
  const { renderMode } = state;
  const descriptor: ComponentDescriptor = uiEngineProps.componentDescriptor;

  return {
    hideComponent:
      renderMode === RenderMode.report && descriptor.properties.displayRiskEvaluationTimeline === false
  };
};
